import React, { Component } from 'react';

// Import Images
import teamMember1 from '../../images/team/member1.jpg';
import teamMember2 from '../../images/team/member2.jpg';
import ptImg1 from '../../images/shap/trangle-orange.png';
import ptImg2 from '../../images/shap/square-dots-orange.png';
import ptImg3 from '../../images/shap/line-circle-blue.png';
import ptImg4 from '../../images/shap/wave-blue.png';
import ptImg5 from '../../images/shap/circle-dots.png';

const teamMembers = [
	{
		name: 'Dra. Fioreella Isamar',
		specialization: 'Odontologo | Especialista en Operatoria y Estética',
		image: teamMember1,
		socialMedia: [
			{ platform: 'Instagram', link: 'https://www.instagram.com/drafioreellaisamar' },
		],
	},
	{
		name: 'Dr. Cesar Arcia',
		specialization: 'Odontologo | Especialista en Ortodoncia y Ortopedia',
		image: teamMember2,
		socialMedia: [
			{ platform: 'Instagram', link: 'https://www.instagram.com/odcesararcia' },
		],
	}
];

class TeamSection extends Component{
	render(){
		return(
			<>
				
				<section className="section-area section-sp3 team-wraper">
					<div className="container">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Nuestro equipo</h6>
							<h2 className="title">Profesionales que te acompañaran</h2>
						</div>
						<div className="row justify-content-center">
							{teamMembers.map((teamMember, index) => (
								<div key={index} className="col-lg-4 col-sm-6 mb-30">
									<div className="team-member">
										<div className="team-media">
											<img src={teamMember.image} alt={teamMember.name} />
										</div>
										<div className="team-info">
											<div className="team-info-content">
												<h4 className="title">{teamMember.name}</h4>
												<span className="text-secondary">{teamMember.specialization}</span>
											</div>
											<ul className="social-media mt-3">
												{teamMember.socialMedia.map((social, index) => (
													<li key={index}>
														<a rel="noopener noreferrer" target="_blank" href={social.link}>
															<i className={`fab fa-${social.platform.toLowerCase()}`} />
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<img className="pt-img1 animate1" src={ptImg1} alt=""/>
					<img className="pt-img2 animate2" src={ptImg2} alt=""/>
					<img className="pt-img3 animate-rotate" src={ptImg3} alt=""/>
					<img className="pt-img4 animate-wave" src={ptImg4} alt=""/>
					<img className="pt-img5 animate-wave" src={ptImg5} alt=""/>
				</section>
				
			</>
		);
	}
}

export default TeamSection;